export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LfVYtksAAAAANDkK8ElRPjBRsRbLlPVV_3lbjHS',
  },

 /* baseUrl: 'https://claimform.tracleerlitigation.com/api/'*/
  baseUrl: 'https://www.googleassistantprivacylitigation.com/api/'
  // baseUrl: 'https://googleassistantprivacylitigation-exclusionhf48r9u9e8f7wegu.azurewebsites.net/api/'
    //baseUrl: 'https://localhost:7249/api/'

};

